import { forwardRef } from "react";

import Box from "@/components/Box";
import Grid from "@/components/Grid";
import { theme } from "@/core/theme";

const BaseRadio = forwardRef(
  ({ name, onChange, value, disabled, color, checked, size = 40 }, ref) => {
    const innerSize = size - 10;
    const inset = (size - innerSize) / 2;

    return (
      <Box position="relative" data-component-name="checkbox">
        <Box
          as="input"
          name={name}
          type="radio"
          value={value}
          position="absolute"
          top={0}
          left={0}
          right={0}
          bottom={0}
          height={size}
          // TODO - this is currently causing a warning in the console
          // if checked is set then onChange is required i think on the input
          // try pointer: none on the overlay and put onChange on here instead
          // of onClick on the overlay
          checked={checked}
          onChange={() => onChange(value)}
          disabled={disabled}
        />
        <Box
          display="block"
          borderRadius="50%"
          width={size}
          height={size}
          borderWidth="2px"
          borderStyle="solid"
          borderColor={color}
          zIndex={1}
          backgroundColor="white"
          position="relative"
          top={0}
          style={{ pointerEvents: "none" }}
        />
        <Box
          position="absolute"
          top={`${inset}px`}
          left={`${inset}px`}
          width={innerSize}
          height={innerSize}
          backgroundColor={color}
          borderRadius="50%"
          opacity={checked ? 1 : 0}
          style={{ pointerEvents: "none", transition: "opacity 250ms" }}
          zIndex={1}
        />
      </Box>
    );
  }
);

BaseRadio.defaultProps = {
  color: "green"
};

const Radio = forwardRef(
  (
    {
      helpText,
      helpTextProps,
      labelProps,
      label,
      error,
      disabled,
      color: _color,
      gridProps,
      size,
      ...props
    },
    ref
  ) => {
    let color = _color;
    if (disabled) {
      color = "midGrey";
    } else if (error) {
      color = theme.colors.red;
    }

    return (
      <Grid gridTemplateColumns="auto 1fr" gridRowGap={0} {...gridProps}>
        <BaseRadio
          color={color}
          size={size}
          {...props}
          ref={ref}
          gridRowStart="1"
          disabled={disabled}
        />
        <Box
          fontFamily="gilroyMedium"
          fontSize={14}
          {...labelProps}
          gridColumnStart="2"
          gridRowStart="1"
          alignSelf="center"
        >
          {label}
        </Box>
        <Box
          fontFamily="gilroyMedium"
          fontSize={14}
          color="midGrey"
          gridColumnStart="2"
          gridRowStart="2"
          {...helpTextProps}
        >
          {helpText}
        </Box>
      </Grid>
    );
  }
);

Radio.defaultProps = {
  color: "green"
};

export { BaseRadio };
export default Radio;
